import React, { createContext, useState } from 'react';

import { merge } from 'lodash';

// Components
import { LayoutSettings } from '@layouts/dashboard/settings';

const SettingsContext = createContext({
  settings: LayoutSettings,
  updateSettings: () => {}
});

export const SettingsProvider = ({ settings, children }) => {
  const [currentSettings, setCurrentSettings] = useState(settings || LayoutSettings);

  const handleUpdateSettings = (update = {}) => {
    const marged = merge({}, currentSettings, update);
    setCurrentSettings(marged);
  };

  return (
    <SettingsContext.Provider
      value={{
        settings: currentSettings,
        updateSettings: handleUpdateSettings
      }}>
      {children}
    </SettingsContext.Provider>
  );
};

export default SettingsContext;
